exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".th-title {\n  min-width: 12em;\n}\n.th-action {\n  min-width: 10em;\n}\na {\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/news/news/news.component.less
// module id = ../../../../../src/app/components/news/news/news.component.less
// module chunks = 0